import {Component, ViewChild} from '@angular/core';
import {ModalController, Nav, Platform} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {JobsPage} from "../pages/jobs/jobs.page";
import {PushService} from "./core/push.service";
import {LocaleService} from "./components/language-picker/locale.service";
import {TimezoneService} from "./components/timezone-picker/timezone.service";
import {SplashScreen} from "@ionic-native/splash-screen";
import {AppAuth} from "./core/auth";
import {LoginPage} from "../pages/login/login.page";
import {RoleService} from "./core/role.service";
import {ContractService} from "./core/contract.service";
import {ContractModal} from "./components/contract-modal/contract-modal.component";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage = JobsPage;

  @ViewChild(Nav) nav: Nav;

  constructor(private platform: Platform,
              private push: PushService,
              private locale: LocaleService,
              private splashScreen: SplashScreen,
              private statusBar: StatusBar,
              private timezone: TimezoneService,
              private auth: AppAuth,
              private role: RoleService,
              private contract: ContractService,
              private modalCtrl: ModalController
  ) {
  }

  ngOnInit(){
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.statusBar.overlaysWebView(false);
      this.splashScreen.hide();

      this.push.init();
      this.locale.init();
      this.timezone.init();
      this.role.init();
    });

    this.auth.getAuthStatus()
      .subscribe((loggedIn) => this.onAuthStatusChange(loggedIn));

    this.role.getRole()
      .subscribe((role) => this.onRoleChange(role));
  }

  private onAuthStatusChange(loggedIn){
    let last = this.nav.last();
    if(loggedIn === false && (!last || last.component.name !== 'LoginPage')){
      this.goToLogin();
    }else if(loggedIn === true){
      this.checkContracts();
    }
  }

  private onRoleChange(role: string) {
    if(role === null){
      this.goToLogin();
    }
  }

  private goToLogin(){
    setTimeout(() => this.nav.setPages([{page: LoginPage}]), 0);
  }

  private checkContracts(){
    this.contract.check('interpreter')
      .subscribe((contract) => {
        if (contract) {
          this.modalCtrl
            .create(
              ContractModal,
              {contract: contract},
              {enableBackdropDismiss: false}
            )
            .present();
        }
      });

    this.contract.check('privacy')
      .subscribe((contract) => {
        if (contract) {
          this.modalCtrl
            .create(
              ContractModal,
              {contract: contract, signature: false},
              {enableBackdropDismiss: false}
            )
            .present();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts